import React from "react";

const Modal_video = ({ setIsOpen }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80">
      <div className="relative w-full max-w-4xl aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl">

        {/* Botón cerrar */}
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-3 right-3 z-10 text-white bg-black/60 rounded-full p-2 hover:bg-black"
        >
          ✕
        </button>

        {/* VIDEO MP4 */}
        <video
          className="w-full h-full"
          src="https://img.invupos.com/webinvu/videomodal/videoheromx-invupos.mp4"
          controls
          autoPlay
        />
      </div>
    </div>
  );
};

export default Modal_video;
